module.exports = __webpack_public_path__ + "static/media/car_button_01.50830eea.png";